(ns app.front.view.property.dashboard.core
  (:require [app.domain.property.model :as property-model]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.not-found :as not-found]
            [app.front.view.property.dashboard.subs :as property-dashboard-subs]
            [app.front.view.property.dashboard.widgets.new-property :as new-property-widget]
            [app.front.view.property.dashboard.widgets.search :as property-search-widget]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.session :as session]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::init
  (fn [{:keys [db]} _]
    (let [user              (:session/user db)
          property-manager? (property-model/user-is-property-manager? user)
          admin?            (session/admin? user)
          fx                [[:dispatch [::property-search-widget/init]]]]
      (if (or property-manager? admin?)
        {:fx (cons [:dispatch [:comm/command-monitored {:command    :property-management/creation-data
                                                        :on-success [::creation-data.success]
                                                        :method     :get}]]
                   fx)}
        {:fx fx}))))

(rf/reg-event-fx ::creation-data.success
  (fn [{:keys [db]} [_ _ creation-data]]
    {:db       (assoc-in db [::property-dashboard-subs/initial-data :authorized-dgs] creation-data)
     :dispatch [::new-property-widget/reset-state]}))

(defn- header [match tr]
  (let [property-manager? (or (<sub [:session/property-manager?])
                              (<sub [:session/admin?]))]
    [ui/page-header (util/mmap match)
     [:div.flex.justify-between.gap-4
      [:h1.bold (tr [:group.feature/property-management])]
      (when property-manager?
        [:div.flex.flex-wrap.gap-4
         (cc/dropdown
           (let [group-id (<sub [::property-search-widget/group-id])]
             {:id            "property-dashboard-more-actions"
              :label         ""
              :title-text    (tr [:more-actions]) ;; Label for screen readers even when it's hidden with :hide-label
              :hide-label    true
              :class-name    "select-action select-wide-menu"
              :items         (cond-> [{:label (tr [:property-gis-import/to-import-button])
                                       :route "view/property-gis-import"}
                                      {:label (tr [:property-gis-import/main-update-heading])
                                       :route "view/property-gis-update"}]
                               (<sub [::ff/enabled? :feature-flag.id/property-mass-delete-domain-group-properties])
                               (conj (p/assoc-if {:label (tr [:property-mass-delete/action])
                                                  :route "view/property-mass-delete"}
                                                 :query (when group-id
                                                          {:domain-group-id group-id}))))
              :selected-item {:label (tr [:more-actions])}
              :on-change     #(let [{:keys [route query]} (some-> (futil/oget % :selectedItem)
                                                                  (js->clj :keywordize-keys true))]
                                (when-let [new-route (some-> route keyword)]
                                  (>evt [:route/push (p/assoc-if {:route new-route}
                                                                 :query query)])))}))
         [:div
          [ui/button {:kind     :primary
                      :size     :field
                      :on-click #(>evt [::property-dashboard-subs/toggle-new-property-visibility])}
           (tr [:property/new-property-record])]]])]]))

(defn dashboard [match]
  (let [tr (<sub [:tr])]
    (if (<sub [:comm/command-processing? :property-management/creation-data])
      (cc/loading-spinner)
      (if (<sub [::property-dashboard-subs/dashboard-access?])
        [:div.cloudpermit-page
         [header match tr]
         (when (<sub [::property-dashboard-subs/new-property-widget-visible?])
           [new-property-widget/view tr])
         [property-search-widget/view tr]]
        [not-found/not-found-view]))))

(def view
  {:name        :view/property-dashboard
   :view        dashboard
   :public?     false
   :controllers [{:start #(>evt [::session/wait-for-user-data [::init]])}]})
